import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";

const footerLinks = {
  produs: [
    { label: "Cum funcționează", href: "/#how-it-works" },
    { label: "Prețuri", href: "/pricing" },
    { label: "Integrare", href: "/integration" },
    { label: "Program Afiliere", href: "/program-afiliere" },
  ],
  legal: [
    { label: "Termeni și Condiții", href: "/terms" },
    { label: "Politica GDPR", href: "/privacy" },
    { label: "Cookie-uri", href: "/cookies" },
  ],
  resurse: [
    { label: "Blog", href: "/blog" },
    { label: "FAQ", href: "/faq" },
    { label: "Suport", href: "/support" },
  ],
};

export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <Logo size="sm" className="[&_span]:text-slate-50" />
            </Link>
            <p className="text-slate-400 mb-6 max-w-sm">
              Optimizează-ți site-ul pentru Google și motoarele AI. Prima soluție
              de SEO + GEO creată special pentru piața din România.
            </p>
            <div className="flex flex-col gap-2 text-sm">
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-primary" />
                <span>contactoptiro@gmail.com</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-primary" />
                <span>București, România</span>
              </div>
            </div>
          </div>

          {/* Links Columns */}
          <div>
            <h4 className="font-semibold text-slate-50 mb-4">Produs</h4>
            <ul className="space-y-3">
              {footerLinks.produs.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-slate-50 mb-4">Legal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-slate-50 mb-4">Resurse</h4>
            <ul className="space-y-3">
              {footerLinks.resurse.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            © 2025 OptiRO.ai. Toate drepturile rezervate.
          </p>
          <p className="text-sm text-slate-500">
            Făcut cu 💚 în România
          </p>
        </div>
      </div>
    </footer>
  );
}
